import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { Utils, Constantes, OperatorUtils } from "@common/utils/";
import { withRouter } from "react-router";

export const hideEmptyStateView = (paginationCount, emptyStateView) => paginationCount !== 0 || !emptyStateView;

export class EmptyStateView extends PureComponent {
    static propTypes = {
        restoreInitialState: PropTypes.func,
        restoreLastState: PropTypes.func,
        deactivateAllFilters: PropTypes.func,
        paginationCount: PropTypes.number.isRequired,
        lastFilter: PropTypes.object,
        totalFavorites: PropTypes.number,
        currentFilter: PropTypes.object,
        isRestoringLastState: PropTypes.bool,
        isRestoringInitialState: PropTypes.bool,
        lastFilterWithProducts: PropTypes.object,
        sort: PropTypes.object,
    };

    constructor() {
        super();
        this.state = {};

        this.buildEmptyStateProps = this.buildEmptyStateProps.bind(this);
        this.handleBackAction = this.handleBackAction.bind(this);
    }

    buildEmptyStateProps() {
        const { paginationCount, emptyStateType } = this.props;

        if (!OperatorUtils.currentCategoryIsOperator()
            && hideEmptyStateView(paginationCount, emptyStateType)) {
            return null;
        }

        let title = 'Sin productos por aquí';
        let subtitle = 'No hay ningún producto en el mercado con estas características';
        let showInitialStateButton = false;
        let showLastStateButton = false;
        let showDeactivateAllFiltersButton = false;
        let icon = Utils.getIcon(Constantes.ICONS_EMPTY_STATES.EMPTY_STATE_SVG);
        if (emptyStateType === Constantes.EMPTY_STATE_TYPE.WITH_ACTIVE_FILTERS) {
            subtitle = <span><span>Te recomendamos volver al último listado con productos</span><br /><span>o desactivar todos los filtros y hacer una nueva búsqueda</span></span>;
            icon = Utils.getIcon(Constantes.ICONS_EMPTY_STATES.EMPTY_STATE_WITH_ACTIVE_FILTERS_SVG);
        } else if (emptyStateType === Constantes.EMPTY_STATE_TYPE.WITH_ACTIVE_FAVORITES || (emptyStateType === Constantes.EMPTY_STATE_TYPE.WITH_ACTIVE_FILTERS_FAVORITES_CANDIDATE && this.props.totalFavorites < 1)) {
            title = "Aquí irían tus favoritos";
            subtitle = <span><span>Marca tus productos para verlos de manera rápida y fácil. </span><br /><span>Puedes marcarlos haciendo click en la estrella al lado de </span><br /><span> cualquier producto en el listado.</span></span>;
            icon = Utils.getIcon(Constantes.ICONS_EMPTY_STATES.EMPTY_STATE_WITH_ACTIVE_FAVORITE_SVG, 218);
        } else if (emptyStateType === Constantes.EMPTY_STATE_TYPE.WITH_ACTIVE_FILTERS_FAVORITES_CANDIDATE && this.props.totalFavorites > 0) {
            title = 'Sin favoritos por aquí';
            subtitle = <span><span>Te recomendamos volver al último listado con productos</span><br /><span>o desactivar todos los filtros y hacer una nueva búsqueda</span></span>;
            icon = Utils.getIcon(Constantes.ICONS_EMPTY_STATES.EMPTY_STATE_WITH_ACTIVE_FILTERS_SVG);
        } else if (emptyStateType === Constantes.EMPTY_STATE_TYPE.SERVER_ERROR) {
            title = 'Algo ha ido mal';
            subtitle = 'Inténtalo de nuevo, a ver si hay más suerte';
            icon = Utils.getIcon(Constantes.ICONS_EMPTY_STATES.EMPTY_STATE_SVG);
        }


        return {
            title,
            subtitle,
            icon,
            showInitialStateButton,
            showLastStateButton,
            showDeactivateAllFiltersButton
        }
    }

    handleBackAction() {
        this.props.history.goBack();
    }

    render() {
        let emptyState = this.buildEmptyStateProps();

        if (!emptyState) {
            return null;
        }
        return (
            <Col md={12} lg={12} className="empty-state-view-container">
                <Card>
                    <CardBody className="card-body-brand">
                        <div className="icon-brand">
                            {emptyState.icon}
                        </div>
                        <div className="title">
                            {emptyState.title}
                        </div>
                        <div className="subtitle">
                            {emptyState.subtitle}
                        </div>
                        <Button size={'sm'} className="last-state-button" outline onClick={this.handleBackAction}>Volver atrás</Button>
                        <div className="message">¿Deseas agregar un producto nuevo a la app? escríbenos a <a href="mailto:soporte@retailcompass.com">soporte@retailcompass.com</a></div>
                    </CardBody>
                </Card>
            </Col>
        );
    }
}

export default withRouter(translate('common')(EmptyStateView));
